import React, { useState } from 'react';
import './CreateTestModal.css';

function CreateTestModal({ isOpen, onClose, onCreate }) {
  const [formData, setFormData] = useState({
    testName: '',
    startUrl: 'https://www.google.com/',
    tunnel: 'Harness Cloud',
    autoLogin: true
  });

  const [urlValid, setUrlValid] = useState(true);
  const localRecorderCommands = `curl -fsSL https://testnocode-production-recorder-339494983496.s3.us-east-1.amazonaws.com/local-recorder/install.sh | bash`;
  const [copied, setCopied] = useState(false);

  if (!isOpen) return null;

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    
    if (field === 'startUrl') {
      // Simple URL validation
      try {
        new URL(value);
        setUrlValid(true);
      } catch {
        setUrlValid(value === '' || value.startsWith('http'));
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (urlValid && formData.startUrl && formData.testName && formData.testName.trim()) {
      onCreate(formData);
      // Reset form
      setFormData({
        testName: '',
        startUrl: 'https://www.google.com/',
        tunnel: 'Harness Cloud',
        autoLogin: true
      });
      onClose();
    }
  };

  const handleCopyCommands = async () => {
    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(localRecorderCommands);
      } else {
        // Fallback copy
        const textarea = document.createElement('textarea');
        textarea.value = localRecorderCommands;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy commands:', err);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Create test</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit} className="create-test-form">
          <div className="form-group">
            <label htmlFor="testName">Test case name *</label>
            <input
              id="testName"
              type="text"
              value={formData.testName}
              onChange={(e) => handleChange('testName', e.target.value)}
              placeholder="Enter test case name"
              className="form-input"
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label htmlFor="startUrl">Start URL *</label>
            <div className="url-input-wrapper">
              <input
                id="startUrl"
                type="text"
                value={formData.startUrl}
                onChange={(e) => handleChange('startUrl', e.target.value)}
                placeholder="http://example.com"
                className={`form-input ${urlValid ? 'valid' : 'invalid'}`}
                required
              />
              {urlValid && formData.startUrl && (
                <span className="url-valid-icon">✓</span>
              )}
            </div>
          </div>

          {/* <div className="form-group">
            <label htmlFor="tunnel">
              Tunnel
              <span className="info-icon" title="Information">ℹ</span>
            </label>
            <select
              id="tunnel"
              value={formData.tunnel}
              onChange={(e) => handleChange('tunnel', e.target.value)}
              className="form-select"
            >
              <option value="Harness Cloud">Harness Cloud</option>
              <option value="None">None</option>
            </select>
          </div> */}

          {/* <div className="form-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={formData.autoLogin}
                onChange={(e) => handleChange('autoLogin', e.target.checked)}
                className="form-checkbox"
              />
              <span>Automatically login</span>
            </label>
          </div> */}

          <div className="form-group">
            <label>Run local recorder (to open browser on this machine)</label>
            <p className="helper-text">
              Run these once in a terminal, then click Create test:
            </p>
            <pre className="code-block">
{localRecorderCommands}
            </pre>
            <button type="button" className="btn-create btn-copy-commands" onClick={handleCopyCommands}>
              {copied ? 'Copied!' : 'Copy commands'}
            </button>
          </div>

          <div className="modal-actions">
            <button type="button" className="btn-cancel" onClick={onClose}>
              Cancel
            </button>
            <button
              type="submit"
              className="btn-create"
              disabled={!urlValid || !formData.startUrl || !formData.testName || !formData.testName.trim()}
            >
              Create test
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateTestModal;
